import { Wrapper } from '@lib/iab/iab-vast-model';

import inheritAd from '../inherit/ad';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    errorHandler: {
        tryRecover: (error: Error) => void;
    };
}

const createWrapper = (
    $ad: UnmarshalerNode,
    options: ParseOptions
): Wrapper => {
    const wrapper = new Wrapper();
    const $wrapper = $ad.wrapper as UnmarshalerNode;
    inheritAd($ad, $wrapper, wrapper, options);

    if ($wrapper.followAdditionalWrappers != null) {
        wrapper.followAdditionalWrappers =
            $wrapper.followAdditionalWrappers as boolean;
    }

    if ($wrapper.allowMultipleAds != null) {
        wrapper.allowMultipleAds = $wrapper.allowMultipleAds as boolean;
    }

    wrapper.fallbackOnNoAd = $wrapper.fallbackOnNoAd as boolean;
    wrapper.vastAdTagURI =
        $wrapper.vastAdTagURI != null
            ? (($wrapper.vastAdTagURI as UnmarshalerNode)._value as string)
            : null;

    return wrapper;
};

export default createWrapper;
